export default [
  'Safer and reliable car',
  'No worries in a critical situation',
  'Avoid expensive repairs',
  'Minimal efforts on car tasks',
  'Online dominated experience',
  'Save time'
];